import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import SearchProduct from "@/components/Shares/SearchProduct";
import { FaTimes } from "react-icons/fa";

interface MenuDrawerProps {
  searchOpen: boolean;
  setSearchOpen: (value: boolean) => void;
}

const SearchDrawer: React.FC<MenuDrawerProps> = (props) => {
  const { searchOpen, setSearchOpen } = props;

  const onClose = () => {
    setSearchOpen(false);
  };

  return (
    <Drawer
      open={searchOpen}
      onClose={onClose}
      direction="top"
      size={600}
      className="!z-[9999]"
      style={{ zIndex: 9999 }}
    >
      <div
        onClick={onClose}
        className="py-4 px-8 border-b border-stroke flex-shrink-0"
      >
        <FaTimes className="cursor-pointer text-xl text-gray-500 hover:text-icon transition-all duration-500" />
      </div>
      <div className="flex items-center p-6 pt-8 flex-col justify-center">
        <SearchProduct resultNumber={5} onClose={onClose} />
      </div>
    </Drawer>
  );
};

export default SearchDrawer;
